import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";

export function EventSkeleton() {
  return (
    <Card className="border-border">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex flex-1 gap-3">
            {/* Avatar Skeleton */}
            <Skeleton className="h-12 w-12 rounded-full" />
            <div className="flex-1 space-y-2">
              {/* Name Skeleton */}
              <Skeleton className="h-4 w-32" />
              {/* Title skeleton */}
              <Skeleton className="h-3 w-48" />
            </div>
          </div>
          {/* Menu button skeleton */}
          <Skeleton className="h-8 w-8 rounded-md" />
        </div>
      </CardHeader>

      <CardContent className="space-y-4 pt-0">
        {/* Event Badge */}
        <Skeleton className="h-6 w-24 rounded-full" />

        {/* Event Title */}
        <Skeleton className="h-6 w-3/4" />

        {/* Event Details Grid */}
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-48" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-40" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-56" />
          </div>
        </div>

        {/* Event Description */}
        <div className="space-y-2">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-2/3" />
        </div>

        <Separator />

        {/* Action Button */}
        <Skeleton className="h-10 w-full rounded-md" />
      </CardContent>
    </Card>
  );
}
